module.exports = __webpack_public_path__ + "c_static/img/6分享二维码.8838c35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/6分享二维码.jpg
// module id = G4KT
// module chunks = 33